"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Autocomplete = void 0;
const react_1 = __importStar(require("react"));
const react_dom_1 = require("react-dom");
const react_intl_1 = require("react-intl");
const clsx_1 = __importDefault(require("clsx"));
const lodash_1 = require("lodash");
const uuid_1 = require("uuid");
const use_debounce_1 = require("use-debounce");
const prompt_context_1 = require("../../composite/prompt/prompt-context");
const prompt_register_hook_1 = require("../../composite/prompt/prompt-register-hook");
const link_button_1 = require("../link-button/link-button");
const text_field_1 = require("../text-field/text-field");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const autocomplate_styles_1 = require("./autocomplate-styles");
const autocomplete_chips_1 = require("./autocomplete-chips");
const autocomplete_context_1 = require("./autocomplete-context");
const autocomplete_disabled_component_1 = require("./autocomplete-disabled-component");
const autocomplete_input_1 = require("./autocomplete-input");
const autocomplete_popup_1 = require("./autocomplete-popup");
const autocomplete_value_hook_1 = require("./hooks/autocomplete-value-hook");
function autocompleteLabelMapper(option) {
    return option.name;
}
function Autocomplete(props) {
    const { disabled, value, onChange, source, multiple = false, labelMapper = autocompleteLabelMapper, linkUrl, DisabledComponent = linkUrl ? text_field_1.TextField : autocomplete_disabled_component_1.AutocompleteDisabledComponent, freeSolo = false, multiline = false, endAdornment, } = props;
    const classes = (0, autocomplate_styles_1.useStyles)();
    const dialogId = (0, react_1.useRef)((0, uuid_1.v4)());
    const { testPrompt } = (0, react_1.useContext)(prompt_context_1.PromptContext);
    (0, prompt_register_hook_1.usePrompts)([
        {
            key: `CONFIRM_CLEAR_${dialogId.current}`,
            dialogTitle: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__AUTOCOMPLETE__DIALOG_CONFIRM__TITLE", defaultMessage: "Varov\u00E1n\u00ED" })),
            dialogText: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__AUTOCOMPLETE__DIALOG_CONFIRM__TEXT", defaultMessage: "Opravdu chcete smazat v\u0161echny polo\u017Eky?" })),
        },
    ], []);
    const autocompleteValue = (0, autocomplete_value_hook_1.useAutocompleteValue)({
        value,
        labelMapper,
        multiple,
        freeSolo,
    });
    const anchorElRef = (0, react_1.useRef)(null);
    const inputRef = (0, react_1.useRef)(null);
    const infiniteListRef = (0, react_1.useRef)(null);
    const [popupOpen, setPopupOpen] = (0, react_1.useState)(false);
    const [textValue, setTextValue] = (0, react_1.useState)('');
    const [setSearchQuery] = (0, use_debounce_1.useDebouncedCallback)((value) => {
        (0, react_dom_1.unstable_batchedUpdates)(() => {
            var _a, _b;
            source.reset();
            source.setSearchQuery(value !== null && value !== void 0 ? value : '');
            (_a = infiniteListRef.current) === null || _a === void 0 ? void 0 : _a.reset();
            if (popupOpen) {
                (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.focus();
            }
        });
    }, 500);
    const invalidTextValue = !multiple && !freeSolo && textValue !== autocompleteValue.getSingleLabel();
    const handleSelectItem = (0, event_callback_hook_1.useEventCallback)(async (option) => {
        var _a;
        if (multiple) {
            // toggle item
            const ids = autocompleteValue.getMultipleIds();
            const isSelected = ids.includes(option.id);
            if (isSelected) {
                const newValue = autocompleteValue.multiple.filter((v) => v.id !== option.id);
                onChange(newValue);
            }
            else {
                option = await source.loadDetail(option);
                onChange([...autocompleteValue.multiple, option]);
            }
        }
        else {
            // select item and close popup
            option = await source.loadDetail(option);
            const value = labelMapper(option, 'FIELD');
            setTextValue(value);
            if (freeSolo) {
                onChange(value);
            }
            else {
                onChange(option);
            }
            setPopupOpen(false);
        }
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    });
    const handleClear = (0, event_callback_hook_1.useEventCallback)((e) => {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        if (freeSolo) {
            onChange('');
            setTextValue('');
            setSearchQuery(null);
        }
        else if (multiple) {
            if (textValue) {
                setTextValue('');
                setSearchQuery(null);
            }
            else if (autocompleteValue.multiple.length) {
                testPrompt({
                    key: `CONFIRM_CLEAR_${dialogId.current}`,
                    submitCallback: () => {
                        onChange([]);
                        setTextValue('');
                        setSearchQuery(null);
                    },
                });
            }
        }
        else {
            onChange(null);
            setTextValue('');
            setSearchQuery(null);
        }
    });
    (0, react_1.useEffect)(() => {
        if (!multiple && !freeSolo) {
            setTextValue(autocompleteValue.getSingleLabel());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [autocompleteValue.single]);
    (0, react_1.useEffect)(() => {
        if (!multiple && freeSolo) {
            setTextValue(autocompleteValue.getTextLabel());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [autocompleteValue.text]);
    (0, react_1.useEffect)(() => {
        if (!multiple && !freeSolo) {
            setTextValue(autocompleteValue.getSingleLabel());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [labelMapper]);
    return (react_1.default.createElement(autocomplete_context_1.AutocompleteContext.Provider, { value: props },
        react_1.default.createElement("div", { "data-cy": "EAS__AUTOCOMPLETE", className: (0, clsx_1.default)('EasInput-root', classes.wrapper, {
                [classes.wrapperDisabled]: disabled,
            }) }, disabled ? (react_1.default.createElement(DisabledComponent, { disabled: true, value: autocompleteValue.getLabel(), onChange: lodash_1.noop, endAdornment: linkUrl &&
                autocompleteValue.single && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(link_button_1.LinkButton, { to: linkUrl(autocompleteValue) }))) })) : (react_1.default.createElement("div", null,
            react_1.default.createElement(autocomplete_input_1.AutocompleteInput, { popupOpen: popupOpen, setPopupOpen: setPopupOpen, textValue: textValue, invalidTextValue: invalidTextValue, setTextValue: setTextValue, setSearchQuery: setSearchQuery, anchorElRef: anchorElRef, inputRef: inputRef, infiniteListRef: infiniteListRef, handleSelectItem: handleSelectItem, handleClear: handleClear, multiline: multiline, endAdornment: endAdornment }),
            !!autocompleteValue.multiple.length && (react_1.default.createElement(autocomplete_chips_1.AutocompleteChips, { values: autocompleteValue.multiple }))))),
        popupOpen && anchorElRef && (react_1.default.createElement(autocomplete_popup_1.AutocompletePopup, { autocompleteValue: autocompleteValue, setPopupOpen: setPopupOpen, invalidTextValue: invalidTextValue, setTextValue: setTextValue, anchorElRef: anchorElRef, infiniteListRef: infiniteListRef, handleSelectItem: handleSelectItem, handleClear: handleClear }))));
}
exports.Autocomplete = Autocomplete;
//# sourceMappingURL=autocomplete.js.map